import { Component, input } from '@angular/core';

/**
 * Up/down chevron used as the affordance for per-column header menus
 * in the data grid. Matches the Figma design spec.
 */
@Component({
  selector: 'lib-column-header-chevron-icon',
  standalone: true,
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 11.667L10.8838 15.4946C10.3977 15.9467 9.60227 15.9467 9.11616 15.4946L5 11.667"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M5 8.33301L9.11616 4.50537C9.60227 4.05333 10.3977 4.05333 10.8838 4.50537L15 8.33301"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class ColumnHeaderChevronIconComponent {
  width = input<string>('20');
  height = input<string>('20');
  color = input<string>('#6B7280');
}
